define('main',[
  'jquery',
  'bootstrap/transition',
  'bootstrap/collapse',
  'bootstrap/modal',
  'bootstrap/dropdown',
  'slick',
  'recaptcha',

  './social/facebook',
  './social/google',
  './social/pinterest',
  './social/twitter'
], function($) {

    $('.bwp-jumbotron')
        .on('init', function() {
            $('.bwp-jumbotron-arrows .prev').on('click', function() {
                $('.bwp-jumbotron').slick('slickPrev');
            });
            $('.bwp-jumbotron-arrows .next').on('click', function() {
                $('.bwp-jumbotron').slick('slickNext');
            });
        })
        .slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            appendArrows: $('.bwp-jumbotron-arrow .slick-arrows')
        });

});
